import { component } from "../../../component-decorators";
import { EventDetailsContent } from "../event-details-content";
import { ToggleFieldBase } from "./toggle-field-base";

@component({
  name: "std-video-conferencing-field",
})
export class VideoConferencingField extends ToggleFieldBase {
  protected label = "Add Video Conferencing";

  static makeWith(): VideoConferencingField {
    const $e = VideoConferencingField.make();
    $e.bind(null, false);
    return $e;
  }

  bind(onChange: Option<(enabled: boolean) => void>, initialEnabled: boolean) {
    this.onChangeCb = onChange;
    this.$switch.setChecked(initialEnabled);
  }
}

export namespace EventDetailsFieldVideoConferencing {
  export function make(): EventDetailsContent.Field<VideoConferencingField> {
    return EventDetailsContent.Field.makeWith(
      VideoConferencingField.makeWith(),
    );
  }
}
